module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-01.d8c1d19c.png";